import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import { SxProps } from "@mui/material";
import { useIsMobile } from "../hooks";

interface Props {
    children?: React.ReactNode;
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    disabled?: boolean;
    width?: string;
    height?: string;
    color?: string;
    background?: string;
    style?: SxProps;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    cancel?: boolean;
    danger?: boolean;
    file?: boolean;
    href?: string;
}

const ReinovaButton: React.FC<Props> = ({
    onClick,
    children,
    disabled,
    width,
    height,
    color,
    background,
    style,
    cancel,
    danger,
    startIcon,
    endIcon,
    file,
    href
}) => {
    const { isMobile } = useIsMobile();

    const other = file ? { component: "label" } : {};
    return (
        <Button
            sx={[
                {
                    color: "white",
                    backgroundColor: "primary.main",
                    height: height ?? 42,
                    width: width ?? null,
                    marginBottom: 2,
                    boxShadow: "16px 16px 20px 0 rgba(0, 0, 0, 0.16)",
                    border: "solid 2px",
                    borderColor: color ?? "secondary.main",
                    borderRadius: "11px",
                    fontSize: isMobile ? "14px" : "16px",
                    pl: "10px",
                    pr: "10px",
                    "&:hover": {
                        backgroundColor: background ?? "#2A2537",
                    },
                    "&:disabled": {
                        color: "#bababa",
                    },
                },
                style ? style : {},
            ].flat(2)}
            disabled={disabled}
            onClick={onClick}
            startIcon={startIcon}
            endIcon={endIcon}
            href={href}
            {...other}
        >
            {children}
        </Button>
    );
};

export default ReinovaButton;
